import { useState } from 'react';
import {
    CssBaseline,
    Box,
    Toolbar,
    List,
    Typography,
    Divider,
    IconButton,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import StudentSideBar from './StudentSideBar';
import { Navigate, Route, Routes } from 'react-router-dom';
import StudentHomePage from './StudentHomePage';
import StudentProfile from './StudentProfile';
import StudentSubjects from './StudentSubjects';
import ViewStdAttendance from './ViewStdAttendance';
import StudentAssignments from './StudentAssignments';
import StudentComplain from './StudentComplain';
import StudentFeePayment from './StudentFeePayment';
import Logout from '../Logout'
import AccountMenu from '../../components/AccountMenu';
import { AppBar, Drawer } from '../../components/styles';
import AIChatWidget from '../../components/AIChatWidget';

const StudentDashboard = () => {
    const [open, setOpen] = useState(true);
    const toggleDrawer = () => {
        setOpen(!open);
    };

    return (
        <>
            <Box sx={{ display: 'flex' }}>
                <CssBaseline />
                <AppBar open={open} position='absolute'>
                    <Toolbar sx={{ pr: '24px' }}>
                        <IconButton
                            edge="start"
                            color="inherit"
                            aria-label="open drawer"
                            onClick={toggleDrawer}
                            sx={{
                                marginRight: '36px',
                                ...(open && { display: 'none' }),
                            }}
                        >
                            <MenuIcon />
                        </IconButton>
                        <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1, gap: 2 }}>
                            {/* Mobile Logo Fallback (shows when drawer is closed on small screens) */}
                            {!open && (
                                <img src="/assets/iitp-logo.png" alt="IIT Patna Logo" style={{ height: '32px' }} />
                            )}
                            <Typography
                                component="h1"
                                variant="h6"
                                color="inherit"
                                noWrap
                                sx={{ fontWeight: 700, letterSpacing: '0.5px' }}
                            >
                                IIT Patna ERP
                            </Typography>
                        </Box>
                        <AccountMenu />
                    </Toolbar>
                </AppBar>
                <Drawer variant="permanent" open={open} sx={open ? styles.drawerStyled : styles.hideDrawer}>
                    <Toolbar sx={{ ...styles.toolBarStyled, justifyContent: 'space-between', px: 2 }}>
                        {open && (
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, py: 1 }}>
                                <img src="/assets/iitp-logo.png" alt="IIT Patna Logo" style={{ height: '40px' }} />
                                <Typography variant="subtitle1" sx={{ fontWeight: 800, color: '#0f172a', lineHeight: 1.2 }}>
                                    IIT Patna<br/>ERP
                                </Typography>
                            </Box>
                        )}
                        <IconButton onClick={toggleDrawer}>
                            <ChevronLeftIcon />
                        </IconButton>
                    </Toolbar>
                    <Divider />
                    <List component="nav">
                        <StudentSideBar />
                    </List>
                </Drawer>
                <Box component="main" sx={styles.boxStyled}>
                    <Toolbar />
                    <Routes>
                        <Route path="/" element={<StudentHomePage />} />
                        <Route path='*' element={<Navigate to="/" />} />
                        <Route path="/Student/dashboard" element={<StudentHomePage />} />
                        <Route path="/Student/profile" element={<StudentProfile />} />

                        <Route path="/Student/subjects" element={<StudentSubjects />} />
                        <Route path="/Student/attendance" element={<ViewStdAttendance />} />
                        <Route path="/Student/assignments" element={<StudentAssignments />} />
                        <Route path="/Student/complain" element={<StudentComplain />} />
                        <Route path="/Student/fees" element={<StudentFeePayment />} />

                        <Route path="/logout" element={<Logout />} />
                    </Routes>
                </Box>
                <AIChatWidget />
            </Box>
        </>
    );
}

export default StudentDashboard

const styles = {
    boxStyled: {
        background: (theme) =>
            theme.palette.mode === 'light'
                ? 'linear-gradient(135deg, #fdfbfb 0%, #ebedee 100%)'
                : theme.palette.grey[900],
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    toolBarStyled: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        px: [1],
    },
    drawerStyled: {
        display: "flex"
    },
    hideDrawer: {
        display: 'flex',
        '@media (max-width: 600px)': {
            display: 'none',
        },
    },
}